import { Slide } from '@/components/core/Slide';

export const slide = () => {
  return (
    <Slide
      notes="Terminal demonstration van Techniekcoalitie Brabant systemen"
      visualizer="full"
      autoNext={22000}
      terminal={{
        phases: [
          {
            type: 'command',
            content:
              'sudo ./breach.sh --target techniekcoalitie******.nl --parallel projectdatabase',
          },
          {
            type: 'matrix',
            content: 'BYPASSING TECHNIEKCOALITIE SECURITY PROTOCOLS...',
          },
          {
            type: 'access',
            content: 'TECHNIEKCOALITIE BRABANT ACCESS ESTABLISHED',
          },
          {
            type: 'command',
            content: 'SELECT * FROM contacts WHERE organization LIKE "%Techniekcoalitie Brabant%"',
          },
          {
            type: 'table',
            content: '',
            header: ['ID', 'NAME', 'ROLE', 'CONTACT'],
            data: [
              ['TCB-001', 'ANN*** V** **', 'Programmamanager | Projectleider', 'www.iv***.nl'],
              ['TCB-002', 'Lin** K****', 'Programmasecretariaat', 'info@techniekcoalitie******.nl'],
              ['TCB-003', 'On** v** d* V**', 'Penvoerder', 'Racefiets enthusiast'],
              ['TCB-004', '', '', '04** *** ***'],
              [
                'TCB-005',
                'Step*** Corp*****',
                'Professor Human Capital',
                'Saxion & TechYourFuture',
              ],
            ],
          },
          {
            type: 'command',
            content:
              './scan_projects.py --organization "Techniekcoalitie Brabant" --type "initiatives"',
          },
          {
            type: 'table',
            content: '',
            header: ['PROJECT', 'FOCUS_AREA', 'STATUS', 'PARTICIPANTS'],
            data: [
              ['AI in Techniek', 'Technical AI Innovation', 'ACTIVE', '25 companies registered'],
              [
                'Futureproof Werkgevers',
                'Workforce Development',
                'ACTIVE',
                '18 organizations registered',
              ],
              ['Smart Industry', 'Digital Transformation', 'PLANNED', '22 companies interested'],
            ],
          },
          {
            type: 'command',
            content: './project_scan.sh --details --silent',
          },
          {
            type: 'matrix',
            content: 'ANALYZING ORGANIZATION PARTICIPATION...',
          },
          {
            type: 'warning',
            content: '[!] TECHNIEKCOALITIE IDS DETECTED - INITIATING EVASION PROTOCOL',
          },
          {
            type: 'command',
            content: './cleanup.sh --secure --remove-logs --stealth',
          },
          {
            type: 'access',
            content: 'OPERATION COMPLETED - DIGITAL FOOTPRINT ELIMINATED',
          },
        ],
        config: {
          typingSpeed: 20,
          phaseDelay: 300,
        },
      }}
      transition="fade"
    >
      <div className="absolute inset-0 z-0" />
    </Slide>
  );
};
